import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import Carousel from "./components/Carousel/Carousel";
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var childrenNode, intro, reactifiedChildren, reactifiedIntro, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            childrenNode = domNode.querySelector("[data-rehydratable-children]");
            intro = domNode.querySelector("[data-rehydratable-intro]");
            _context.next = 4;
            return rehydrateChildren(childrenNode);

          case 4:
            reactifiedChildren = _context.sent;
            _context.next = 7;
            return rehydrateChildren(intro);

          case 7:
            reactifiedIntro = _context.sent;
            props = {
              intro: reactifiedIntro
            };

            if (!(reactifiedChildren.type === React.Fragment)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", /*#__PURE__*/React.createElement(Carousel, props, reactifiedChildren.props.children));

          case 11:
            return _context.abrupt("return", /*#__PURE__*/React.createElement(Carousel, props, reactifiedChildren));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();